import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import {createNamespace, acceptCssUnit as unit} from '../../common/utils';
import {getComponentName} from '../../common/utils/namespace';
import './index.css';

var _createNamespace = createNamespace('panel'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    name: getComponentName('Panel'),
    props: {
        background: {
            type: String,
            default: ''
        },
        href: {
            type: String
        },
        width: {
            type: [Number, String]
        },
        height: {
            type: [Number, String]
        },
        radius: {
            type: [Number, String],
            default: 0
        },
        inline: {
            type: Boolean,
            default: false
        }
    },
    render: function render() {
        var h = arguments[0];
        var Tag = this.href ? 'a' : 'div';
        return h(
            Tag,
            {
                class: b(),
                attrs: {
                    href: this.href
                },
                on: {
                    click: this.handleClick
                },
                style: this.style
            },
            [this.$slots.default]
        );
    },
    computed: {
        style: function style() {
            return {
                'border-radius': this.radius ? unit(this.radius) : '',
                overflow: this.radius ? 'hidden' : '',
                background: this.background,
                width: unit(this.width),
                height: unit(this.height),
                display: this.inline ? 'inline-block' : 'block'
            };
        }
    },
    methods: {
        handleClick: function handleClick(e) {
            this.$emit('click', e);
        }
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
